import {Component, OnInit} from '@angular/core';
import {NbDialogRef} from '@nebular/theme';
import {Router} from '@angular/router';
import {BaseDialog} from '../base-dialog';

@Component({
  selector: 'app-invalid-project-dialog',
  templateUrl: './invalid-project-dialog.component.html',
  styleUrls: ['./invalid-project-dialog.component.css']
})
export class InvalidProjectDialogComponent extends BaseDialog<InvalidProjectDialogComponent> implements OnInit {

  constructor(dialogRef: NbDialogRef<InvalidProjectDialogComponent>, route: Router) {
    super(dialogRef, route);
  }

  ngOnInit() {
  }
}
